import { useSaveRecentSearch } from 'Pages/Home/Hooks/useSaveUserRecentSearch';
import { Row } from 'antd';
import * as React from 'react';
import { useHistory } from 'react-router';
import ButtonCard from '../../Atoms/ButtonCard';
import Styles from './SearchMoreButton.module.scss';
import { TSearchMoreButton } from './definitions';
import useSaveSearch from 'Pages/Home/Hooks/useSaveSearch';

export default function SearchMoreButton({
  keyword,
  total,
  afterClick,
  userId,
  isFetching,
}: TSearchMoreButton) {
  const { postSaveRecentSearch, postSaveSearchActivity } = useSaveSearch({
    category: 'all_category',
    userId,
  });
  const history = useHistory();
  const onClick = () => {
    if (userId) {
      postSaveRecentSearch(keyword);
      postSaveSearchActivity(keyword);
    }
    history.push(`/search?keyword=${keyword.split(' ').join('+')}`);
    if (afterClick) afterClick();
  };

  const renderText = () => (
    <React.Fragment>
      <span>Browse All </span>
      <span style={{ fontFamily: 'DMSans-Bold' }}>{keyword} </span>
      <span>({total})</span>
    </React.Fragment>
  );

  return (
    <Row align="middle" justify="center" className={Styles['search-more-row']}>
      <ButtonCard
        text={renderText()}
        isFetching={isFetching}
        onClick={onClick}
      />
    </Row>
  );
}
